import { render, staticRenderFns } from "./StaffBinding.vue?vue&type=template&id=6b730296&"
import script from "./StaffBinding.vue?vue&type=script&lang=js&"
export * from "./StaffBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports